import { api } from "./api";

const normalizeFieldArray = (list = []) => {
  if (list.every((item) => typeof item === "string")) {
    return list.map((name) => ({
      field_Name: name,
      default_Value: "",
    }));
  }
  return list;
};

const extractFieldsArray = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return normalizeFieldArray(payload);
  if (Array.isArray(payload?.case_fields)) return normalizeFieldArray(payload.case_fields);
  if (Array.isArray(payload?.result)) return normalizeFieldArray(payload.result);
  if (Array.isArray(payload?.fields)) return normalizeFieldArray(payload.fields);
  if (typeof payload === "object") {
    return Object.entries(payload).map(([key, value]) => ({
      field_Name: key,
      default_Value: value,
    }));
  }
  return [];
};

export const fetchConfirmDetailsFields = async (caseNumber) => {
  const { data } = await api.get("/everify/confirm-details-fields", {
    params: { caseNumber },
  });
  return extractFieldsArray(data);
};

export const submitConfirmDetails = async (caseNumber, valuesArray) => {
  return api.post(
    "/everify/confirm-details",
    valuesArray,
    { params: { caseNumber } }
  );
};

export const retrievePhoto = async (caseNumber) => {
  const { data } = await api.get("/everify/retrieve_photo", {
    params: { caseNumber },
  });
  const url =
    data?.url ||
    data?.photoUrl ||
    data?.photo_url ||
    data?.documentPhoto ||
    data?.result?.url ||
    data?.result?.photoUrl ||
    null;
  return typeof url === "string" && url.length > 0 ? url : null;
};

export const submitPhotoMatch = async (caseNumber, decision) => {
  return api.post("/everify/photo_match", decision, {
    params: { caseNumber },
    headers: { "Content-Type": "application/json" },
  });
};

export const scanAndUploadDocuments = async (caseNumber, frontFile, backFile) => {
  const formData = new FormData();
  formData.append("FrontPhoto", frontFile);
  formData.append("BackPhoto", backFile);
  return api.post("/everify/scan_and_upload", formData, {
    params: { caseNumber },
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadFurtherActionNotice = async (caseNumber) => {
  const { data } = await api.get("/everify/further_action_notice", {
    params: { caseNumber },
    responseType: "blob",
  });
  downloadBlob(data, `further-action-${caseNumber || "case"}.pdf`);
};

export const downloadReferralDate = async (caseNumber) => {
  const { data } = await api.get("/everify/referral_date_confirmation", {
    params: { caseNumber },
    responseType: "blob",
  });
  downloadBlob(data, `referral-date-${caseNumber || "case"}.pdf`);
};

export const submitNoAction = async (caseNumber, body = {}) => {
  const payload = {
    ...body,
    employee_notified: true,
  };
  return api.post(
    "/everify/no_action",
    payload,
    { params: { caseNumber } }
  );
};

export async function referCase(caseNumber) {
  if (!caseNumber) {
    throw new Error("Case number is required to refer a case");
  }

  const response = await fetch(
    `/everify/refer?case_number=${caseNumber}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to refer case");
  }

  return response.json();
}


export const submitReferCase = async (caseNumber, body = {}) => {
  const payload = {
    ...body,
    employee_notified: true,
  };
  return api.post("/everify/refer", payload, { params: { caseNumber } });
};

const normalizeClosureReasons = (raw = []) =>
  raw.map((reason) => {
    if (typeof reason === "string") {
      return { code: reason, name: reason };
    }
    return {
      code: reason?.code || reason?.value || reason?.id || "",
      name:
        reason?.name ||
        reason?.label ||
        reason?.description ||
        reason?.code ||
        "Closure Reason",
    };
  });

export const fetchClosureReasons = async (caseNumber) => {
  const { data } = await api.get("/everify/closure_reasons", {
    params: { caseNumber },
  });
  if (Array.isArray(data)) return normalizeClosureReasons(data);
  if (Array.isArray(data?.case_Closure_Reasons)) {
    return normalizeClosureReasons(data.case_Closure_Reasons);
  }
  if (Array.isArray(data?.reasons)) return normalizeClosureReasons(data.reasons);
  if (Array.isArray(data?.result)) return normalizeClosureReasons(data.result);
  return [];
};

export const submitCloseCase = async (caseNumber, payload) => {
  return api.post("/everify/closecase", payload, { params: { caseNumber } });
};

export const downloadGenericResult = async (caseNumber, filename = "everify-result.pdf") => {
  const { data } = await api.get("/everify/further_action_notice", {
    params: { caseNumber },
    responseType: "blob",
  });
  downloadBlob(data, filename);
};

export const fetchCaseStatus = async (caseNumber) => {
  const { data } = await api.get("/everify/casestatus", {
    params: { caseNumber },
  });
  return data;
};
